module.exports = __webpack_public_path__ + "static/media/flags_FRA.4b83a013.svg";